export const PARENTS = [
  {
    label: 'createTenant.atruvia',
    value: 'atruvia',
  },
  {
    label: 'createTenant.smm',
    value: 'smm',
  },
  {
    label: 'createTenant.none',
    value: '',
  },
];

export const MODES = [
  {
    label: 'createTenant.KWS',
    value: 'KWS',
  },
  {
    label: 'createTenant.KWH',
    value: 'KWH',
  },
  {
    label: 'createTenant.BOTH',
    value: 'BOTH',
  },
];
